const initialState = {
    customersList: [],
    totalCustomersCount: 0,
    hierarchyData: []
};

const customerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CUSTOMERS_LIST': {
            return {
                ...state,
                customersList: action.payload.customers,
                totalCustomersCount: action.payload.totalCount || 0,
            };
        }
        case 'HIERARCHY_DATA': {
            let hierarchyData = [];
            hierarchyData.push(action.payload);
            return {
                ...state,
                hierarchyData
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default customerReducer;